var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2H22V5.5C22 6.9375 20.875 8 19.5 8H16.5C15.0625 8 14 6.9375 14 5.5V2H12C10.875 2 10 2.9375 10 4V12H8V4C8 1.8125 9.75 0 12 0H16H20H24C26.1875 0 28 1.8125 28 4V12H26V4C26 2.9375 25.0625 2 24 2ZM16 2V5.5C16 5.8125 16.1875 6 16.5 6H19.5C19.75 6 20 5.8125 20 5.5V2H16ZM20.4375 32C20.9375 31.4375 21.375 30.75 21.625 30H32C33.0625 30 34 29.125 34 28V18C34 16.9375 33.0625 16 32 16H30V19.5C30 20.9375 28.875 22 27.5 22H24.5C23.0625 22 22 20.9375 22 19.5V18V16H21.625C21.375 15.3125 20.9375 14.625 20.4375 14H24H28H32C34.1875 14 36 15.8125 36 18V28C36 30.25 34.1875 32 32 32H20.4375ZM24 16V19.5C24 19.8125 24.1875 20 24.5 20H27.5C27.75 20 28 19.8125 28 19.5V16H24ZM16 16H14V19.5C14 20.9375 12.875 22 11.5 22H8.5C7.0625 22 6 20.9375 6 19.5V16H4C2.875 16 2 16.9375 2 18V28C2 29.125 2.875 30 4 30H16C17.0625 30 18 29.125 18 28V18C18 16.9375 17.0625 16 16 16ZM8 19.5C8 19.8125 8.1875 20 8.5 20H11.5C11.75 20 12 19.8125 12 19.5V16H8V19.5ZM16 14C18.1875 14 20 15.8125 20 18V28C20 30.25 18.1875 32 16 32H4C1.75 32 0 30.25 0 28V18C0 15.8125 1.75 14 4 14H6H8H12H14H16Z",
    fill: "#E66E2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxes);
export default __webpack_public_path__ + "static/media/boxes.43c695c38b88c6bdeb402f255345346a.svg";
export { ForwardRef as ReactComponent };